import { ApiProviderAuthenticated, ErrorToast, ToastQueueProvider } from '@idu-nightlife/ui-kit';
import { SnackbarProvider } from 'notistack';
import { AppProviders } from './app/components/app-providers/app-providers';
import { AppRoutes } from './app/components/app-routes/app-routes';
import { CONFIG } from './config';
import './global.css';

function App() {
  return (
    <AppProviders>
      <ApiProviderAuthenticated
        baseUrl={CONFIG.API_BASE_URL}
        cacheKey="idu-manager"
        appName="manager"
      >
        <SnackbarProvider maxSnack={3}>
          <ToastQueueProvider>
            <ErrorToast />
            <AppRoutes />
          </ToastQueueProvider>
        </SnackbarProvider>
      </ApiProviderAuthenticated>
    </AppProviders>
  );
}

export default App;
